












































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Invoice from "@/store/entities/invoice";
import VueBarcode from "vue-barcode";
import Print from "vue-print-nb";
import _ from "lodash";
Vue.use(Print);
@Component({
  components: { barcode: VueBarcode },
})
export default class PrinterPurchaseOrder extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 1 }) width: number;
  @Prop({ type: Number, default: 30 }) height: number;
  @Prop({ type: String, default: "svg" }) type: String;
  @Prop({ type: String, default: "Arial" }) font: String;
  @Prop({ type: String, default: "12" }) fontSize: String;
  code: string = "";
  options: any = {
    format: "CODE128",
    background: "#fff",
  };
  currentDate: Date = new Date();
  sumOrderQty: number = 0;

  get poForPrinter() {
    var re = this.$store.state.purchaseOrder.purchaseOrderForPrinter;
    this.sumOrderQty = _.sumBy(re.items, "qty");
    return re;
  }

  get loading() {
    return false;
  }

  columns = [
    {
      title: this.L("STT"),
      width: 50,
      align: "center",
      key: "orderNum",
    },
    {
      title: this.L("Mã hàng hóa"),
      align: "left",
      key: "sku",
    },
    {
      title: this.L("Tên sản phẩm"),
      align: "left",
      key: "productName",
    },
    {
      title: this.L("Đơn vị tính"),
      align: "left",
      key: "unitName",
    },
    {
      title: this.L("Số lượng"),
      align: "right",
      key: "qty",
    },
    {
      title: this.L("Serials"),
      align: "left",
      key: "strSerial",
    },
  ];

  async created() {
    this.code = this.$root.$router.currentRoute.params.code;
    await this.$store.dispatch({
      type: "purchaseOrder/getDataPoForPrinter",
      data: { code: this.code },
    });
  }
}
